<script setup lang="ts">

import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {customerApi} from "@/container";
import {computed, reactive} from "vue";
import dateHelper from "@/core/helpers/dateHelper";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import BaseCardHeader from "@/core/components/base/BaseCardHeader.vue";
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import {useRouter} from "vue-router";

const params = reactive({certified: true, page: 1, limit: 10});
const {data, isValidating} = useSwr(
    computed(() => cacheKey('customers', params)),
    () => customerApi().get(params)
);
const router = useRouter();

const headers = [
    {
        title: "Nom",
        key: "name",
        value: (item) => item.information?.name ?? 'Anonyme'
    },
    {
        title: "Date de certification",
        key: "certification_date",
        value: (item) => dateHelper.shortFormat(item.validated_at)
    },
    {
        title: "Date de dernière visite",
        key: "last_visit_date",
        value: (item) => item.last_visit?.date ? dateHelper.mediumFormat(item.last_visit?.date) : ''
    }
];

const handleLimitChange = (limit: number) => {
    params.page = 1;
    params.limit = limit;
};
</script>

<template>
  <div>
    <HeaderBackButton title="Patients certifiés" />
    <div class="p-4">
      <BaseCard>
        <BaseCardHeader>
          Patients certifiés sur l'application Apodis
        </BaseCardHeader>
        <BaseCardBody>
          <v-data-table-server
            :loading="isValidating"
            :items="data?.data ?? []"
            :items-length="data?.meta.total"
            :items-per-page="params.limit"
            :headers="headers"
            :page="params.page"
            @update:items-per-page="handleLimitChange"
            @update:page="(page: number) => params.page = page"
            @click:row="(event, row) => router.push({name: 'customer.home', params: {customerId: row.item.id}})"
          />
        </BaseCardBody>
      </BaseCard>
    </div>
  </div>
</template>

